import defaultPrivacy from './defaultPrivacy'
import mountControlOriginSearch from './mountControlOriginSearch'
import parseControlOrigin from './parseControlOrigin'

const privacyPoliciesHelper = {
  defaultPrivacy,
  mountControlOriginSearch,
  parseControlOrigin,
}

export default privacyPoliciesHelper
